<template>
  <div class="ctrl-home-buttons">
    <h2>一般</h2>
    <el-row class="items" :gutter="50">
      <el-col :span="8">
        <router-link to="/ctrl/notifications">
          <Button2 msg="全体連絡" />
        </router-link>
      </el-col>
      <el-col :span="8">
        <router-link to="/ctrl/users">
          <Button2 msg="ユーザー検索" />
        </router-link>
      </el-col>
      <el-col :span="8">
        <router-link to="/ctrl/gives-points">
          <Button2 msg="ポイント付与" />
        </router-link>
      </el-col>
    </el-row>
    <el-row class="items" :gutter="50">
      <el-col :span="8">
        <router-link to="/ctrl/affiliate">
          <Button2 msg="アフィリエイト" />
        </router-link>
      </el-col>
      <el-col :span="8">
        <router-link to="/ctrl/value-commercers">
          <Button2 msg="バリューコマース公開設定" />
        </router-link>
      </el-col>
    </el-row>
    <h2>広告成果連携ツール</h2>
    <el-row :gutter="50">
      <el-col :span="8">
        <router-link to="/ctrl/parameter-log">
          <Button2 msg="パラメータログ" />
        </router-link>
      </el-col>
      <el-col :span="8">
        <router-link to="/ctrl/auto-import-log">
          <Button2 msg="自動登録履歴" />
        </router-link>
      </el-col>
      <el-col :span="8">
        <Button2 msg="レポート" />
      </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="8">
        <router-link to="/ctrl/bridges">
          <Button2 msg="atidログ" />
        </router-link>
      </el-col>
      <el-col :span="8">
        <router-link to="/ctrl/api-histories">
          <Button2 msg="API送信履歴" />
        </router-link>
      </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="8">
        <router-link to="/ctrl/tools02/cart-system">
          <Button2 msg="カートシステム" />
        </router-link>
      </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="8">
        <router-link to="/ctrl/browser-test-tool">
          <Button2 msg="ブラウザテストツール" />
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Button2 from "@/components/Ui/Button2.vue";

export default {
  name: "buttons",
  data() {
    return {};
  },
  components: {
    Button2,
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: left;
  border: none;
  margin-top: 35px;
}
</style>
